import { c as _c } from "react/compiler-runtime";
import { type Locale, type StaticTranslationString } from '@/types/types';
import React, { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
const nextStepText: StaticTranslationString = {
  en: 'Next',
  de: 'Weiter',
  fr: 'Suivant'
};
const previousStepText: StaticTranslationString = {
  en: 'Previous',
  de: 'Zurück',
  fr: 'Précédent'
};
const pleaseWaitText: StaticTranslationString = {
  en: 'Loading, please wait...',
  de: 'Laden, bitte warten...',
  fr: 'Chargement, veuillez patienter'
};
const uploadingText: StaticTranslationString = {
  en: 'Uploading file...',
  de: 'Datei wird hochgeladen...',
  fr: 'Téléversement du fichier...'
};
interface FormControlsProperties {
  locale: Locale;
  isFirst: boolean;
  isLast: boolean;
  isSubmitting: boolean;
  onNext: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onPrev: (event: React.MouseEvent<HTMLButtonElement>) => void;
  submitLabel?: string;
  formId?: string;
}
export const FormControls: React.FC<FormControlsProperties> = t0 => {
  const $ = _c(24);
  const {
    locale,
    isFirst,
    isLast,
    isSubmitting,
    onNext,
    onPrev,
    submitLabel,
    formId
  } = t0;
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formValues = useWatch(t1) as Record<string, unknown> | undefined;
  let t2;
  bb0: {
    if (formValues === undefined) {
      t2 = false;
      break bb0;
    }
    let t3;
    if ($[2] !== formValues) {
      t3 = Object.entries(formValues).some(_temp);
      $[2] = formValues;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = t3;
  }
  const isFileUploading = t2;
  const isDisabled = isSubmitting || isFileUploading;
  let t3;
  if ($[4] !== isFileUploading || $[5] !== isSubmitting || $[6] !== locale) {
    t3 = defaultLabel => {
      if (isSubmitting) {
        return pleaseWaitText[locale];
      }
      if (isFileUploading) {
        return uploadingText[locale];
      }
      return defaultLabel;
    };
    $[4] = isFileUploading;
    $[5] = isSubmitting;
    $[6] = locale;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getActionButtonLabel = t3;
  let t4;
  if ($[8] !== isDisabled || $[9] !== isFirst || $[10] !== locale || $[11] !== onPrev) {
    t4 = isFirst ? <span className="hidden sm:block sm:w-1/3" /> : <button type="button" onClick={onPrev} disabled={isDisabled} className="flex h-auto min-h-10 w-full cursor-pointer items-center justify-center rounded-lg border-2 border-gray-500 px-4 py-2 text-center text-sm font-semibold text-gray-500 transition duration-100 hover:bg-gray-100 disabled:opacity-50 sm:w-auto sm:text-base">{previousStepText[locale]}</button>;
    $[8] = isDisabled;
    $[9] = isFirst;
    $[10] = locale;
    $[11] = onPrev;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== formId || $[14] !== getActionButtonLabel || $[15] !== isDisabled || $[16] !== isLast || $[17] !== locale || $[18] !== onNext || $[19] !== submitLabel) {
    t5 = isLast ? <button key="submit" type="submit" disabled={isDisabled} form={formId} className="bg-conveniat-green flex h-auto min-h-10 w-full cursor-pointer items-center justify-center rounded-lg px-4 py-2 text-center text-sm font-bold text-gray-100 transition duration-100 hover:bg-green-700 disabled:opacity-50 sm:w-auto sm:text-base">{getActionButtonLabel(submitLabel ?? "")}</button> : <button key="next" type="button" onClick={onNext} disabled={isDisabled} className="bg-conveniat-green flex h-auto min-h-10 w-full cursor-pointer items-center justify-center rounded-lg px-4 py-2 text-center text-sm font-bold text-gray-100 transition duration-100 hover:bg-green-700 disabled:opacity-50 sm:w-auto sm:text-base">{getActionButtonLabel(nextStepText[locale])}</button>;
    $[13] = formId;
    $[14] = getActionButtonLabel;
    $[15] = isDisabled;
    $[16] = isLast;
    $[17] = locale;
    $[18] = onNext;
    $[19] = submitLabel;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t4 || $[22] !== t5) {
    t6 = <div className="mt-2 flex flex-col space-y-3 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">{t4}{t5}</div>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};
function _temp(t0) {
  const [key, value] = t0;
  return key.startsWith("_isUploading_") && value === true;
}